import { render, staticRenderFns } from "./DashboardBlock.vue?vue&type=template&id=73a282d0&"
import script from "./DashboardBlock.vue?vue&type=script&lang=ts&"
export * from "./DashboardBlock.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardBlock.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports